import { Redirect } from "react-router-dom";

import {
  LoginPage,
  LogoutPage,
  ForgetPasswordPage,
  VerificationPage,
  GovernoratesPage,
  CitiesPage,
  SchoolsPage,
  ResetPasswordPage,
  SettingsTabPage,
  ControlAppTabsPage,
  FeaturesPage,
  SubjectsTabPage,
  SubjectDetailPage,
  SubjectsLegacyRedirect,
  TeacherAdminsPage,
  HeadTeacherAdminsPage,
  SystemAdminsPage,
  AdminsPage,
  PromoCodePage,
  TeacherUsersPage,
  ComplaintsPage,
  ReportsPage,
  EnableDisablePage,
  PlansTabPage,
  PlansLegacyRedirect,
  StudentUsersV2Page,
  TransactionHistoryV2Page,
  LogsPage,
  ContactsPage,
  CategoriesPage,
  AcademicCalendarPage,
  LiveLecturePage,
  PrivateLiveLecturePage,
  SubscriptionReportPage,
  EducationSystemsPage,
  CurriculaPage,
  EducationalStagesPage,
  MediaConversionStatusPage,
  TestersPage,
} from "../pages";
import { CommentReviewsPage } from "../pages/Reviews";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import { ParentUsersPage } from "../pages/Users/AppUsers/ParentUsers";
import NotifyUsersPage from "../pages/NotifyUsers/NotifyUsers";
import { NotificationsPage } from "../pages/NotifyUsers";
import FileManagerPage from "../pages/FileManager";
import { RoleEnum } from "../enums";
import DashboardPage from "../pages/Dashboard/Dashboard";
export const SuperAdminRoutes: any[] = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  { path: "/dashboard", component: DashboardPage },
  { path: "/governorates", component: GovernoratesPage },
  { path: "/cities", component: CitiesPage },
  { path: "/schools", component: SchoolsPage },
  { path: "/subjects", component: SubjectsTabPage, exact: true },
  { path: "/subjects/:course/:gradeId?", component: SubjectsLegacyRedirect },
  {
    path: "/subjects/:course/:gradeId/:subjectId",
    component: SubjectDetailPage,
    exact: false,
  },
  { path: "/control-app", component: ControlAppTabsPage },
  { path: "/control-app/features", component: FeaturesPage },
  { path: "/control-app/enable-disable", component: EnableDisablePage },
  { path: "/education-system/systems", component: EducationSystemsPage },
  { path: "/education-system/curricula", component: CurriculaPage },
  {
    path: "/education-system/educational-stages",
    component: EducationalStagesPage,
  },
  { path: "/settings", component: SettingsTabPage },
  { path: "/academic-calendar", component: AcademicCalendarPage },
  { path: "/live-lectures", component: LiveLecturePage },
  { path: "/meetings", component: PrivateLiveLecturePage },
  { path: "/users/cp-users/teacher-admins", component: TeacherAdminsPage },
  {
    path: "/users/cp-users/head-teachers",
    component: HeadTeacherAdminsPage,
  },
  {
    path: "/users/cp-users/system-admins",
    component: SystemAdminsPage,
  },
  { path: "/users/cp-users/admins", component: AdminsPage },
  { path: "/users/app-users/students", component: StudentUsersV2Page },
  { path: "/users/app-users/parents", component: ParentUsersPage },
  { path: "/users/app-users/teachers", component: TeacherUsersPage },
  {
    path: "/users/testers",
    component: TestersPage,
    allowedRoles: [RoleEnum.SUPER_ADMIN],
  },
  { path: "/payment/transaction-history", component: TransactionHistoryV2Page },
  { path: "/payment/promo-codes", component: PromoCodePage },
  { path: "/payment/plans", component: PlansTabPage, exact: true },
  { path: "/payment/plans/:course", component: PlansLegacyRedirect },
  { path: "/notifications/notify", component: NotifyUsersPage },
  { path: "/notifications/list", component: NotificationsPage },
  { path: "/complaints", component: ComplaintsPage },
  { path: "/reports", component: ReportsPage },
  { path: "/reports/subscription", component: SubscriptionReportPage },
  { path: "/reviews/comment-reviews", component: CommentReviewsPage },
  {
    path: "/logs",
    component: LogsPage,
    allowedRoles: [RoleEnum.SUPER_ADMIN],
  },
  {
    path: "/monitoring/media-conversion-status",
    component: MediaConversionStatusPage,
    allowedRoles: [RoleEnum.SUPER_ADMIN],
  },
  { path: "/contacts", component: ContactsPage },
  { path: "/categories", component: CategoriesPage },
  { path: "/file-manager", component: FileManagerPage },
  { path: "not-found", component: Alt404 },
  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];

/**
 * System Admin: near–Super Admin surface, scoped to assigned education systems.
 * Denied: education-system module, payments (except transaction history),
 * complaints, reports, control-app, categories, contacts, file-manager,
 * monitoring, private meetings, logs.
 * Under Users: Application students/parents/teachers only (no CP Administration).
 */
export const SystemAdminRoutes: any[] = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  { path: "/dashboard", component: DashboardPage },
  { path: "/governorates", component: GovernoratesPage },
  { path: "/cities", component: CitiesPage },
  { path: "/schools", component: SchoolsPage },
  { path: "/subjects", component: SubjectsTabPage, exact: true },
  { path: "/subjects/:course/:gradeId?", component: SubjectsLegacyRedirect },
  {
    path: "/subjects/:course/:gradeId/:subjectId",
    component: SubjectDetailPage,
    exact: false,
  },
  { path: "/settings", component: SettingsTabPage },
  { path: "/academic-calendar", component: AcademicCalendarPage },
  { path: "/live-lectures", component: LiveLecturePage },
  { path: "/payment/transaction-history", component: TransactionHistoryV2Page },
  { path: "/users/app-users/students", component: StudentUsersV2Page },
  { path: "/users/app-users/parents", component: ParentUsersPage },
  { path: "/users/app-users/teachers", component: TeacherUsersPage },
  { path: "/notifications/notify", component: NotifyUsersPage },
  { path: "/notifications/list", component: NotificationsPage },
  { path: "/reviews/comment-reviews", component: CommentReviewsPage },
  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];

export const TeacherAdminRoutes: any[] = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  { path: "/dashboard", component: DashboardPage },
  { path: "/subjects", component: SubjectsTabPage, exact: true },
  { path: "/subjects/:course/:gradeId?", component: SubjectsLegacyRedirect },
  {
    path: "/subjects/:course/:gradeId/:subjectId",
    component: SubjectDetailPage,
    exact: false,
  },
  { path: "/settings", component: SettingsTabPage },
  { path: "/file-manager", component: FileManagerPage },
  { path: "/live-lectures/live-lectures", component: LiveLecturePage },
  { path: "/reviews/comment-reviews", component: CommentReviewsPage },
  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];

/** Head Teacher Admin: same as Teacher Admin; live lectures scoped to assigned education systems */
export const HeadTeacherAdminRoutes: any[] = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  { path: "/dashboard", component: DashboardPage },
  { path: "/subjects", component: SubjectsTabPage, exact: true },
  { path: "/subjects/:course/:gradeId?", component: SubjectsLegacyRedirect },
  {
    path: "/subjects/:course/:gradeId/:subjectId",
    component: SubjectDetailPage,
    exact: false,
  },
  { path: "/settings", component: SettingsTabPage },
  { path: "/file-manager", component: FileManagerPage },
  { path: "/live-lectures/live-lectures", component: LiveLecturePage },
  { path: "/reviews/comment-reviews", component: CommentReviewsPage },
  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];

/** Admin: Head Teacher Admin surface + students/parents management */
export const AdminRoutes: any[] = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
  },
  { path: "/dashboard", component: DashboardPage },
  { path: "/subjects", component: SubjectsTabPage, exact: true },
  { path: "/subjects/:course/:gradeId?", component: SubjectsLegacyRedirect },
  {
    path: "/subjects/:course/:gradeId/:subjectId",
    component: SubjectDetailPage,
    exact: false,
  },
  { path: "/users/app-users/students", component: StudentUsersV2Page },
  { path: "/users/app-users/parents", component: ParentUsersPage },
  { path: "/settings", component: SettingsTabPage },
  { path: "/file-manager", component: FileManagerPage },
  { path: "/live-lectures/live-lectures", component: LiveLecturePage },
  { path: "/reviews/comment-reviews", component: CommentReviewsPage },
  { path: "not-found", component: Alt404 },
  { path: "*", exact: true, component: Alt404 },
];
export const PublicRoutes: any = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/login" />,
  },
  { path: "/login", component: LoginPage },
  { path: "/logout", component: LogoutPage },
  { path: "/forget-password", component: ForgetPasswordPage },
  {
    path: "/verification/:phone",
    component: VerificationPage,
  },
  {
    path: "/reset-password/:phone/:code",
    component: ResetPasswordPage,
  },
];
